/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactroutinglettertimesaved4Inputs */

const en_artifactroutinglettertimesaved4 = /** @type {(inputs: Artifactroutinglettertimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves looking up your district's competent forum (Julgado de Paz / arbitration / court) from the dates and amount you provided`)
};

const pt_artifactroutinglettertimesaved4 = /** @type {(inputs: Artifactroutinglettertimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poupa procurar o foro competente do seu distrito (Julgado de Paz / arbitragem / tribunal) a partir das datas e do valor que indicou`)
};

/**
* | output |
* | --- |
* | "Saves looking up your district's competent forum (Julgado de Paz / arbitration / court) from the dates and amount you provided" |
*
* @param {Artifactroutinglettertimesaved4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactroutinglettertimesaved4 = /** @type {((inputs?: Artifactroutinglettertimesaved4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactroutinglettertimesaved4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactroutinglettertimesaved4(inputs)
	return pt_artifactroutinglettertimesaved4(inputs)
});
export { artifactroutinglettertimesaved4 as "artifactRoutingLetterTimeSaved" }